import {selectIsViewOnly} from 'hsi/selectors';
import {useAppSelector} from './useRedux';

export default function useIsViewOnly() {
    return useAppSelector(selectIsViewOnly);
}
